import React from 'react';
import css from './DealerFooter.module.scss';
import { formatAsPhoneNumber } from '../../../helpers/Number';
import { useLocalization } from '../../../context/Localization/localization';
import { useKioskState } from '../../../context/Kiosk/kiosk';

export const DealerFooter: React.FC = () => {
    const Localization = useLocalization();
    const {
        dealer: { name, phone, website },
    } = useKioskState();

    return (
        <div className={css.dealerInformation}>
            <br />
            <h2 className={css.dealerName}>{name}</h2>
            <p className={css.dealerNumber}>
                <a href={'tel:' + phone} title={Localization.ClickToCallOurDealership}>
                    {formatAsPhoneNumber(phone)}
                </a>
            </p>
            <br />
            <p className={css.dealerWebsite}>
                <a href={website} title={Localization.ClickToAccessOurWebsite}>
                    {website}
                </a>
            </p>
        </div>
    );
};